const l = {
  name: "Gmail",
  dimensions: { width: 40, height: 32 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 32" style="enable-background:new 0 0 40 32;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,26.4l-10-10V32H0V6c0-3.3,2.7-6,6-6h0.9c1.6,0,3.1,0.6,4.2,1.7l0,0l8.8,8.8l8.8-8.8C30,0.6,31.5,0,33.1,0
			H34c3.3,0,6,2.7,6,6v1h0v25H30V16.4L20,26.4z M2,5.6l6,6V2.1C7.7,2,7.3,2,6.9,2H6C3.9,2,2.2,3.6,2,5.6z M32,14.4V30h6V8.4L32,14.4
			z M32,11.6l6-6c-0.2-2-1.9-3.6-4-3.6h-0.9c-0.4,0-0.7,0-1.1,0.1V11.6z M30,3.4l-10,10l-10-10v10.2l10,10l10-10V3.4z M2,8.4V30h6
			V14.4L2,8.4z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as Gmail
};
